export default {
  title: 'Verotiedot',
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    success: 'Tietosi tallennettiin onnistuneesti.',
  },
};
